import { DatePipe, NgClass } from "@angular/common";
import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	signal,
} from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { from, map } from "rxjs";
import { NotificationType } from "src/app/enums";
import { ApiService } from "../../../../services/api.service";
import { NotificationService } from "../../../../services/notification/notification.service";
import { UserStorageService } from "../../../../services/user-storage.service";
import { IconPipe } from "../../../shared/pipes/icon/icon.pipe";

@Component({
	selector: "app-notifications",
	templateUrl: "./notifications.component.html",
	styleUrls: ["./notifications.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [NgClass, DatePipe, TranslatePipe, IconPipe],
})
export class NotificationsComponent {
	readonly #notificationService = inject(NotificationService);
	readonly #router = inject(Router);
	readonly #route = inject(ActivatedRoute);

	readonly notificationType = toSignal(
		this.#route.paramMap.pipe(map((params) => params.get("notificationType"))),
		{ initialValue: null },
	);

	readonly #allMessages = toSignal<any>(
		from(this.#notificationService.getMessages()),
		{ initialValue: [] as any },
	);

	readonly messages = computed(() => {
		const all = this.#allMessages();
		const type = this.notificationType();

		let filtered = all;
		if (type === "whistleblower") {
			filtered = all.filter(
				(message: any) => message.Type === NotificationType.whistleblower,
			);
		}

		return [...filtered].sort((a: any, b: any) => {
			const newDiff = b.IsNew - a.IsNew;
			if (newDiff !== 0) return newDiff;
			return b.CreatedDate.Epoch - a.CreatedDate.Epoch;
		});
	});

	showMessage(id: string): void {
		this.#router.navigate(["notifications/message/" + id]);
	}

	back(): void {
		window.history.back();
	}
}
